import React from 'react';
import './TopLinksTable.css';

/**
 * Tableau des top liens cliqués
 * @param {Array} links - Liste des liens [{original_url, click_count, percentage, signature_name}, ...]
 * @param {string} title - Titre du tableau
 */
function TopLinksTable({ links = [], title = 'Top liens cliqués' }) {
    // Extraire le domaine d'une URL
    const extractDomain = (url) => {
        try {
            const urlObj = new URL(url);
            return urlObj.hostname.replace('www.', '');
        } catch {
            return url.substring(0, 30);
        }
    };

    // Obtenir l'icône du type de lien
    const getLinkIcon = (elementType) => {
        const icons = {
            'social_linkedin': '🔗',
            'social_twitter': '🐦',
            'social_facebook': '📘',
            'social_instagram': '📷',
            'social_youtube': '▶️',
            'button': '🔘',
            'image': '🖼️',
            'text': '📝',
            'banner': '🏷️'
        };
        return icons[elementType] || '🔗';
    };

    if (!links || links.length === 0) {
        return (
            <div className="top-links-table empty">
                <h3>{title}</h3>
                <p className="empty-message">Aucun clic enregistré pour cette période</p>
            </div>
        );
    }

    return (
        <div className="top-links-table">
            <h3>{title}</h3>
            <div className="links-list">
                {links.map((link, index) => (
                    <div key={link.id || index} className="link-item">
                        <div className="link-rank">{index + 1}</div>
                        <div className="link-icon">{getLinkIcon(link.element_type)}</div>
                        <div className="link-info">
                            <a
                                href={link.original_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link-url"
                                title={link.original_url}
                            >
                                {link.link_label || extractDomain(link.original_url)}
                            </a>
                            {link.signature_name && (
                                <span className="link-signature">{link.signature_name}</span>
                            )}
                        </div>
                        <div className="link-stats">
                            <span className="link-count">{link.click_count.toLocaleString('fr-FR')} clics</span>
                            <div className="link-bar-container">
                                <div
                                    className="link-bar"
                                    style={{ width: `${link.percentage}%` }}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default TopLinksTable;
